export default __webpack_public_path__ + "static/media/matias-jaluf-2.f0ff9ef5.webp";